module.exports = __webpack_public_path__ + "img/farming_52.e1245507.png";